import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { RESET_PASSWORD } from 'constants/ActionTypes';

import AuthService from '@src/services/AuthService';

import { errorNotification, userResetPasswordSuccess, userResetPasswordError } from '../actions';

const authService = new AuthService();

function* resetPassword({ payload }) {
  try {
    yield call([authService, authService.requestPasswordReset], payload);
    yield put(userResetPasswordSuccess(payload));
  } catch (error) {
    yield put(errorNotification(error.toString()));
    yield put(userResetPasswordError());
  }
}

export function* userResetPassword() {
  yield takeEvery(RESET_PASSWORD, resetPassword);
}

export default function* rootSaga() {
  yield all([fork(userResetPassword)]);
}
